import React from "react";
import { intlShape, IntlProvider } from "react-intl";
import { getLang, getMessages } from "./i18n/i18nDataBuilder";

function flattenMessages(nestedMessages, prefix = "") {
	return Object.keys(nestedMessages).reduce((messages, key) => {
		const value = nestedMessages[key];
		const prefixedKey = prefix ? `${prefix}.${key}` : key;

		if (typeof value === "string") {
			messages[prefixedKey] = value;
		} else {
			Object.assign(messages, flattenMessages(value, prefixedKey));
		}

		return messages;
	}, {});
}

const flatMsgs = flattenMessages(getMessages());
const locale = getLang();
const intlProps = {
	locale,
	messages: flatMsgs,
};
export const intlProvider = new IntlProvider(intlProps, {});
export function withIntlRoot<P>(Component: React.ComponentType<P>) {
	return class WithIntlRoot extends React.Component<P> {
		static displayName = `withIntlRoot(${Component.displayName ?? Component.name})`;
		static contextTypes = {
			intl: intlShape.isRequired,
		};
		static childContextTypes = {
			intl: intlShape.isRequired,
		};
		static defaultProps = {
			...intlProvider.getChildContext(),
		};

		getChildContext() {
			return intlProvider.getChildContext();
		}

		render() {
			return <Component {...this.props} />;
		}
	};
}
